import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import {
  Button,
  GridContainer,
  GridColumn,
  GridRow,
  Img,
  Loader,
  Modal,
  Toastr,
  Utils,
} from "arv-reactcomponents";
import BodyOverlay from "../../BodyOverlay";
import AddressBlockWrapper from "../../AddressBlockWrapper";
import AddAddress from "../../ReturnComponent/AddAddress";

import { MYACCOUNTPAGE, blackboltConfig, Endpoints } from "npmlinks-constants";

const { ACCOUNT_ADDRESS_LIST } = MYACCOUNTPAGE;

Toastr.setConfig({
  limitTo: 1,
});

@inject("AddressStore")
@observer
class AccountAddressList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      address: {},
      id: "",
      showAddAddressModal: false,
      loader: false,
    };

    this.showAddAddress = this.showAddAddress.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
    this.handleAddAddress = this.handleAddAddress.bind(this);
    this.closeAddAddress = this.closeAddAddress.bind(this);
    this.removeAddress = this.removeAddress.bind(this);
    this.setAddressDefault = this.setAddressDefault.bind(this);
  }

  showAddAddress() {
    this.setState({ showAddAddressModal: true });
  }

  updateAddress(addressId) {
    this.setState({
      showAddAddressModal: true,
      id: addressId.id,
      address: addressId,
      edit: true,
    });
  }

  handleAddAddress(address, addressId, edit) {
    let promise;
    if (edit && addressId) {
      promise = this.props.AddressStore.editAddress(address, addressId);
    } else {
      promise = this.props.AddressStore.addAddressCall(address, true, false);
    }
    this.setState({ loading: true });
    promise
      .then(res => {
        this.setState({
          showAddAddressModal: false,
          id: "",
          address: {},
          edit: false,
          loading: false,
        });
      })
      .catch(err => {
        this.setState({
          showAddAddressModal: true,
          loading: false,
        });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: blackboltConfig.ERROR_MSG,
          timeout: 3000,
        });
      });
  }

  closeAddAddress() {
    this.setState({
      showAddAddressModal: false,
      id: "",
      address: {},
      edit: false,
    });
  }

  removeAddress(addressId) {
    BodyOverlay.component.show();
    this.props.AddressStore.removeAddress(addressId).then(
      () => {
        BodyOverlay.component.hide();
        this.props.AddressStore.getUserAddresses();
      },
      () => {
        BodyOverlay.component.hide();
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: blackboltConfig.ERROR_MSG,
          timeout: 3000,
        });
      },
    );
  }

  setAddressDefault(addressId) {
    BodyOverlay.component.show();
    this.props.AddressStore.setAddressDefault(addressId).then(
      () => {
        BodyOverlay.component.hide();
        this.props.AddressStore.getUserAddresses();
      },
      () => {
        BodyOverlay.component.hide();
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: blackboltConfig.ERROR_MSG,
          timeout: 3000,
        });
      },
    );
  }

  get addressListComponent() {
    const { userAddresses } = this.props.AddressStore;
    return (
      <GridColumn className="nw-accountaddresslist-list">
        <Button
          className="nw-accountaddresslist-addadrssbtnborder"
          onClick={this.showAddAddress}
        >
          <div className="nw-accountaddresslist-addadrssbtntxt">
            {ACCOUNT_ADDRESS_LIST.addAddressButton}
          </div>
        </Button>
        {userAddresses.map(address => (
          <AddressBlockWrapper.component
            className="nw-accountaddressblockwrapper-addrswrapper"
            address={address}
            key={address.id}
            isDefault={address.isDefault}
            onEditClick={this.updateAddress}
            onRemoveAddress={this.removeAddress}
            onSelect={Utils.noop}
            onSetAddressDefault={this.setAddressDefault}
          />
        ))}
      </GridColumn>
    );
  }

  get noAddressComponent() {
    return (
      <GridColumn className="nw-accountaddresslist-empty">
        <Img
          className="nw-accountaddresslist-noaddress"
          src={Endpoints.noAddressImage}
          alt="No Address"
        />
        <h2 className="nw-accountaddresslist-title">
          {ACCOUNT_ADDRESS_LIST.noAddressComponentTitle}
        </h2>
        <span className="nw-accountaddresslist-description">
          {ACCOUNT_ADDRESS_LIST.noAddressComponentSubHeader}
        </span>
        <div className="nw-accountaddresslist-addadrssbtnwrap">
          <Button
            className="nwc-btn-primary nw-accountaddresslist-addadrssbtn"
            onClick={this.showAddAddress}
          >
            {ACCOUNT_ADDRESS_LIST.addAddressButton}
          </Button>
        </div>
      </GridColumn>
    );
  }

  render() {
    const { userAddresses } = this.props.AddressStore;
    const { addressLoader } = this.props;
    const { showAddAddressModal, edit, id, address } = this.state;
    const isAddress = userAddresses && userAddresses.length > 0;
    return (
      <GridContainer className="nw-accountaddresslist-container">
        <GridRow className="nw-accountaddresslist-row">
          {addressLoader && <Loader className="nw-accountaddresslist-loader" />}
          {!addressLoader && !isAddress && this.noAddressComponent}
          {!addressLoader && isAddress && this.addressListComponent}
          <Modal isOpen={showAddAddressModal} onClose={this.closeAddAddress}>
            <AddAddress.component
              edit={edit}
              editableAddress={address}
              id={id}
              onAddressSave={this.handleAddAddress}
              showLocalLoader={this.state.loading}
            />
          </Modal>
        </GridRow>
      </GridContainer>
    );
  }
}

AccountAddressList.defaultProps = {
  previous: PropTypes.func,
};

AccountAddressList.wrappedComponent.propTypes = {
  addressLoader: PropTypes.bool.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onRemoveAddress: PropTypes.func.isRequired,
  AddressStore: PropTypes.shape({
    getUserAddresses: PropTypes.func.isRequired,
    userAddresses: PropTypes.shape({}),
  }).isRequired,
};

const getFinalComponent = component =>
  inject("AddressStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AccountAddressList.wrappedComponent,
  component: AccountAddressList,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/AccountAddressList/index.js